module.exports = __webpack_public_path__ + "7e4b29ba/img/upload-icon.9179ae4e.svg";